import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const mapUnitToApiUnitDto = (values: IEditUnitForm): IPostEditUnit | {} => {
  let dataMapping: IPostEditUnit;
  const unknown = -1;

  if (values.placeID === undefined) { return {} };

  dataMapping = {
    description: values.description,
    placeID: +values.placeID !== 0 ? +values.placeID : unknown,
    unID: values.unID,
    deleted: values.deleted,
    isEmporiki: values.isEmporiki,
    isCiti: values.isCiti,
    hubType: values.hubType,
    anetVoice: values.anetVoice,
    comments: values.comments,
    filepath: values.filepath,
    sapCode: values.sapCode,
  }
  
  return dataMapping;
}


const editUnit = ( {data, unitId} : {data: IEditUnitForm , unitId: number}): Promise<string> => {
  const unit = mapUnitToApiUnitDto(data);
  return axiosDefaultApi.patch(`/api/Units/UpdateUnit/${unitId}`, unit);
};

type QueryFnType = typeof editUnit;

type UseEditUnitOptions = {
  data: IPostEditUnit | {};
  unitId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useEditUnit = ({ config }: UseEditUnitOptions) => { 
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην επεξεργασία της Μονάδας.`, 500);
            console.error('Couldnt edit Unit', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllUnits"])
            addNotification('Η Μονάδα Ενημερώθηκε.', 200);
            setIsNotificationVisible(true)
          },
        ...config,
        mutationFn: editUnit,
    })
}